import Top from '@/frontend/src/Top';

function HomePage() {
  return <Top />;
}

export default HomePage;
